import { OrganizationSafeHarborPricingSettingsV2, OrganizationSettingsV2 } from 'types';

import { api } from './api';

export const equipmentSettingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOrganizationEquipmentSettings: build.query<
      OrganizationSettingsV2<OrganizationSafeHarborPricingSettingsV2>[],
      { alias: string; programType: string }
    >({
      query: ({ alias, programType }) => ({
        url: `/organizations/${alias}/pricing-settings`,
        params: { programType },
      }),
      transformResponse: (response: { data: OrganizationSettingsV2<OrganizationSafeHarborPricingSettingsV2>[] }) =>
        response.data,
      providesTags: (_result, _error, { alias, programType }) => [
        { type: 'OrganizationEquipmentSettings', id: `${alias}-${programType}` },
      ],
    }),
    createOrganizationEquipmentSetting: build.mutation<
      OrganizationSettingsV2<OrganizationSafeHarborPricingSettingsV2>,
      { alias: string; programType: string; data: Omit<OrganizationSafeHarborPricingSettingsV2, 'status'> }
    >({
      query: ({ alias, programType, data }) => ({
        url: `/organizations/${alias}/pricing-settings`,
        method: 'PUT',
        params: { programType },
        body: data,
      }),
      invalidatesTags: (_result, _error, { alias, programType }) => [
        { type: 'OrganizationEquipmentSettings', id: `${alias}-${programType}` },
      ],
    }),
    archiveOrganizationEquipmentSetting: build.mutation<
      void,
      { alias: string; settingId: string; programType: string }
    >({
      query: ({ alias, settingId, programType }) => ({
        url: `/organizations/${alias}/pricing-settings/${settingId}`,
        method: 'DELETE',
        params: { programType },
      }),
      invalidatesTags: (_result, _error, { alias, programType }) => [
        { type: 'OrganizationEquipmentSettings', id: `${alias}-${programType}` },
      ],
    }),
  }),
});

export const {
  useGetOrganizationEquipmentSettingsQuery,
  useLazyGetOrganizationEquipmentSettingsQuery,
  useCreateOrganizationEquipmentSettingMutation,
  useArchiveOrganizationEquipmentSettingMutation,
} = equipmentSettingsApi;
